import React, { useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';

import { Button, Card, CardContent, Checkbox, CircularProgress, FormControlLabel, Link, TextField } from '@mui/material';
import { AppPage } from '@shared';
import { ta } from 'utils';

import ShopifyLogo from 'images/shopify-2025.svg';

const propTypes = {
  submitURL: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  shopifyLoginURL: PropTypes.string.isRequired,
};


const SignIn = (props) => {
  const [checked, setChecked] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = useCallback((newChecked) => setChecked(newChecked), []);
  const htmlForm = useRef(null);

  const submitForm = () => {
    setLoading(true);
    htmlForm.current.submit();
  }

  const handleShopifyLogin = (e) => {
    e.preventDefault();
    document.getElementById('shopify-login-form').submit();
  };

  const csrfToken = document.querySelector("meta[name=csrf-token]").content;

  return (
      <AppPage
        title="Inicio de Sesión"
      >
        <Card>
          <CardContent>

          <form
            ref={ htmlForm }
            action={ props.submitURL }
            method="post"
          >
            <TextField
              fullWidth
              margin="normal"
              label={ ta("user.email") }
              placeholder="foo@bar.com"
              name="user[email]"
              value={ email }
              onChange={ (event) => setEmail(event.target.value) }
              InputLabelProps={{ shrink: true }}
            />

            <TextField
              fullWidth
              margin="normal"
              label={ ta("user.password") }
              placeholder="*****"
              name="user[password]"
              type="password"
              value={ password }
              onChange={ (event) => setPassword(event.target.value) }
              InputLabelProps={{ shrink: true }}
            />

            <FormControlLabel
              label="Recuérdame"
              control={
                <Checkbox
                  checked={checked}
                  onChange={(event) => handleChange(event.target.checked)}
                />
              }
            />
            <div className="mt4 mb8">
              <Link href={props.forgotPasswordLink}>
                ¿Olvidaste tu contraseña?
              </Link>
            </div>


            <input name="user[remember_me]" type="hidden" value={ checked } />
            <input type="hidden" name="authenticity_token" value={csrfToken} />

            <div className="mt4">
              <Button
                variant="contained"
                type="submit"
                fullWidth
                disabled={loading}
                startIcon={ loading ? <CircularProgress size={16} color="inherit" /> : null }
                onClick={ submitForm }
              >
                Ingresar
              </Button>

              <div className="shopify-button-wrapper mt12">
                <Button
                  variant="outlined"
                  color="inherit"
                  onClick={handleShopifyLogin}
                  fullWidth
                >
                  <div className='flex alignItemsCenter'>
                    <img src={ShopifyLogo} alt="Shopify" height={32} className='mr5' />
                    Ingresar con Shopify
                  </div>
                </Button>
              </div>
            </div>
          </form>

          {/* to add forgot password link */}

          {/* Omniauth V2 requires URL to be a POST request */}
          <form 
            id="shopify-login-form" 
            action={props.shopifyLoginURL} 
            method="post" 
            style={{ display: 'none' }}
          >
            <input 
              type="hidden" 
              name="authenticity_token" 
              value={csrfToken} 
            />
          </form>

          </CardContent>
        </Card>
      </AppPage>
  )
}


SignIn.propTypes = propTypes;


export default SignIn;
